import { render, staticRenderFns } from "./DomainEventIndex.vue?vue&type=template&id=49121e32&scoped=true&"
import script from "./DomainEventIndex.vue?vue&type=script&lang=js&"
export * from "./DomainEventIndex.vue?vue&type=script&lang=js&"
import style0 from "./DomainEventIndex.vue?vue&type=style&index=0&id=49121e32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49121e32",
  null
  
)

export default component.exports